import { httpRequest } from '@/utils/HttpRequest'
import { IPage, IPageRet, IRet, ISearchPage } from '@/types/AppTypes'
import { getBaseFmsRequestUrl } from '@/utils/constants'
import { getBaseCiRequestUrl, getToken } from '@/utils/constants'


export interface IMdBeDetail {
    address?: string
    application?: string
    applicationName?: string
    bank?: string
    bankAcct?: string
    branch?: string
    code?: string
    corporation?: string
    createTime?: string
    createUser?: string
    deleteFlag?: number
    enable?: number
    id: string
    licenseNo?: string
    name: string
    note?: string
    orderNum?: string
    phone?: string
    status?: string
    traceId?: string
    updateTime?: string
    updateUser?: string
    ver?: string
}

class CommonService {
    async bePage(searchVo?: any, config: object = {}) {
        const apiUrl = '/yh-franchisee/bentity/find'
        return await httpRequest.post<IMdBeDetail[]>(apiUrl, searchVo, { baseURL: getBaseCiRequestUrl(), token: getToken() })
    }

    // 用户自定义设置
    //查询一条
    async userCustomizeConfigOne(key: string) {
        const apiUrl = `/yh-franchisee/user/customize/config/one/${key}`
        return await httpRequest.get<any>(apiUrl, { baseURL: getBaseCiRequestUrl(), token: getToken() })
    }
    //新增一条
    async userCustomizeConfigSave(data: {}) {
        const apiUrl = '/yh-franchisee/user/customize/config/save'
        return await httpRequest.post<boolean>(apiUrl, data, { baseURL: getBaseCiRequestUrl(), token: getToken() })
    }

}

export const commonService = new CommonService()
